import dynamicAPI from './dynamicAPI'
import { useMutation, useQueryClient } from 'react-query'

const url = '/api/auth/branch-users'

const queryKey = 'users'

export default function useUsersHook() {
    const queryClient = useQueryClient()

    const getBranchUsersByBranch = useMutation(
        queryKey,
        async (id) => await dynamicAPI('get', `${url}/${id}`, {}),
        {
            retry: 0
        }
    )

    const putBranchUser = useMutation(
        async (obj) => await dynamicAPI('put', `${url}/${obj.idUser}`, obj.data),
        {
            retry: 0,
            onSuccess: () => queryClient.invalidateQueries([queryKey]),
        }
    )

    const deleteBranchUser = useMutation(
        async (id) => await dynamicAPI('delete', `${url}/${id}`, {}),
        {
            retry: 0,
            onSuccess: () => queryClient.invalidateQueries([queryKey]),
        }
    )

    const postBranchUser = useMutation(
        async (obj) => await dynamicAPI('post', url, obj),
        {
            retry: 0,
            onSuccess: () => queryClient.invalidateQueries([queryKey]),
        }
    )

    const postMultipleBranchUsers = useMutation(
        async (users) => await dynamicAPI('post', `${url}/multiple-users`, users),
        {
            retry: 0,
            onSuccess: () => queryClient.invalidateQueries([queryKey]),
        }
    )

    return { getBranchUsersByBranch, putBranchUser, deleteBranchUser, postBranchUser, postMultipleBranchUsers }
}
